import React, { Component } from 'react';
import NoticePostItem from './NoticePostItem';

class NoticePost extends Component {
	constructor(props) {
		super(props);

		const blogPostData = {
			blogPostList: [
				{
					id: 1,
					imgUrl: require('../../assets/img/blog/post/p1.jpg'),
					heading: 'The Importance of Onboarding Users to Your App',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '13th Oct, 2018',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo'
				},
				{
					id: 2,
					imgUrl: require('../../assets/img/blog/post/p2.jpg'),
					heading: 'The Importance of Onboarding Users to Your App',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '13th Oct, 2018',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo'
				},
				{
					id: 3,
					imgUrl: require('../../assets/img/blog/post/p3.jpg'),
					heading: 'The Importance of Onboarding Users to Your App',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '13th Oct, 2018',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo'
				},
				{
					id: 4,
					imgUrl: require('../../assets/img/blog/post/p4.jpg'),
					heading: 'The Importance of Onboarding Users to Your App',
					thumbUrl: require('../../assets/img/blog/post/user-thumb.png'),
					writer: 'Marvel Maison',
					date: '13th Oct, 2018',
					post_type: 'Image Post',
					post_cat: 'Food & Travel',
					post_comment: '03 Comments',
					post_info:
						'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo'
				}
			]
		};

		this.state = blogPostData;
	}

	render() {
		const blogPostItems = this.state.blogPostList.map((item) => {
			return (
				<NoticePostItem
					key={item.id}
					imgUrl={item.imgUrl}
					heading={item.heading}
					thumbUrl={item.thumbUrl}
					writer={item.writer}
					date={item.date}
					post_type={item.post_type}
					post_cat={item.post_cat}
					post_comment={item.post_comment}
					post_info={item.post_info}
				/>
			);
		});

		return (
			<section className="post-area">
				{blogPostItems}
			</section>
		);
	}
}

export default NoticePost;
